import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { switchMap } from "rxjs/operators";
import { throwError, of, Observable } from "rxjs";
import {
  EscalationInput,
  SupportCategory,
  SupportInput,
} from "../models/support";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class SupportService {
  constructor(private api: ApiService, private auth: AuthService) {}

  send(
    categoryKey: string,
    payload: SupportInput,
    captcha: string = null
  ): Observable<boolean> {
    return this.api
      .get(
        `mutation sendSupportTicket($key: String!, $payload: SupportTicketInput!) {
      sendSupportTicket(
        key: $key,
        payload: $payload
      ){
        ... on GeneralResponse{
          success
        }
        ... on OperationError{
          errors{
            message
            field
          }
        }
    }
  }`,
        {
          key: categoryKey,
          payload: payload,
        },
        this.auth.getToken() ? true : false,
        false,
        captcha
      )
      .pipe(
        switchMap((response) => {
          const data = response["data"]["sendSupportTicket"];

          if (data["errors"]) {
            return throwError(data);
          }

          return of(data["success"]);
        }),
        this.api.unifyErrors()
      );
  }

  getCategories(): Observable<SupportCategory[]> {
    return this.api
      .get(
        `query SupportTicketCategories{
      supportTicketCategories{
        key
        label
        subCategories
                  {
                  key
                  label
                  text   
                }
            }
      }`,
        {},
        null,
        this.auth.getToken() ? true : false
      )
      .pipe(
        switchMap((response) => {
          if (response["errors"]) {
            return throwError(response);
          }

          return of(response["data"]["supportTicketCategories"]);
        }),
        this.api.unifyErrors()
      );
  }
  sendEscalationTicket(
    payload: EscalationInput,
    captcha: string = null
  ): Observable<boolean> {
    return this.api
      .get(
        `mutation SendEscalationTicket(
  $escalationType: EscalationType!
  $ticketID: Int!
  $email: String!
  $description: String!
  $documents: [FileUploadInput] 
) {
  sendEscalationTicket(
    escalationType: $escalationType
    ticketID: $ticketID
    email: $email
    description: $description
    documents: $documents
  ) {
    ... on GeneralResponse {
      success
    }
    ... on OperationError {
      errors {
        message
        field
      }
    }
  }
}
`,
        payload,
        this.auth.getToken() ? true : false,
        false,
        captcha
      )
      .pipe(
        switchMap((response) => {
          const data = response["data"]["sendEscalationTicket"];

          if (data["errors"]) {
            return throwError(data);
          }

          return of(data["success"]);
        }),
        this.api.unifyErrors()
      );
  }
}
